export default "__VITE_ASSET__dac8fc6b__"